import PracticePage from "@/components/PracticePage";
import CTABanner from "@/components/CTABanner";
import FAQ from "@/components/FAQ";
import { useSEO } from "@/lib/seo";

export default function RealEstate() {
    useSEO({
        title: "Real Estate & Title Attorneys | Land, Farms, Commercial",
        description:
            "Real estate law for rural and commercial property: purchases, sales, title, leases, easements, and closings.",
        path: "/real-estate-law",
        schema: {
            "@context": "https://schema.org",
            "@type": "Service",
            serviceType: "Real Estate Law",
            provider: { "@type": "LegalService", name: "Chesterton" }
        }
    });

    return (
        <>
            <PracticePage
                slug="real-estate-law"
                kicker="Practice · Real Estate"
                title={<>Land is the asset. Get the paperwork right.</>}
                lede="Farm ground, timber tracts, commercial parcels, family homesteads. We handle the legal side of buying, selling, leasing, and holding real property. Every deed clear, every survey reconciled, every closing on time."
                heroImg="https://static.prod-images.emergentagent.com/jobs/dc9b61c8-b672-42d3-b6b9-0bd9d83af141/images/f3f952cb549b6641abce6a1ae0e387fab3fcc39322fa73bae78b328072ba94f4.png"
                bullets={[
                    "Residential and rural property purchases and sales",
                    "Commercial real estate transactions",
                    "Title examinations and curative work",
                    "Title insurance through licensed underwriters",
                    "Farm and hunting leases",
                    "Easements, rights-of-way, and access",
                    "1031 like-kind exchanges and closings"
                ]}
                sections={[
                    {
                        h: "Purchases and sales, done deliberately.",
                        p: "From contract through closing, we keep the timeline tight and the paperwork clean. We draft and negotiate purchase agreements, coordinate with surveyors and lenders, and prepare deeds and closing documents that match what was actually negotiated."
                    },
                    {
                        h: "Title examined the way it should be.",
                        p: "We pull and examine title back through the chain, flag liens and clouds, and resolve them before they become someone else’s problem. For closings, we coordinate title insurance and disburse funds as a neutral party."
                    },
                    {
                        h: "Leases that match how the land is used.",
                        p: "Cash rent, crop-share, hunting, billboard, solar, cell-tower: each kind of lease has its own quirks. We draft lease language that reflects how you actually use the ground and protects against the issues that crop up years in."
                    }
                ]}
            />
            <FAQ />
            <CTABanner />
        </>
    );
}
